import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin")({
  head: () => ({
    meta: [
      { title: "Admin - Mr. Pizza Steve Finds" },
    ],
  }),
  component: lazyRouteComponent(() => import("./admin.lazy")),
});